<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.625 9.375H19.5312M15.625 12.5H19.5312M15.625 15.625H19.5312M4.6875 20.3125H20.3125C21.6069 20.3125 22.6562 19.2632 22.6562 17.9687V7.03125C22.6562 5.73683 21.6069 4.6875 20.3125 4.6875H4.6875C3.39308 4.6875 2.34375 5.73683 2.34375 7.03125V17.9687C2.34375 19.2632 3.39308 20.3125 4.6875 20.3125ZM10.9375 9.76562C10.9375 10.8443 10.0631 11.7187 8.98438 11.7187C7.90569 11.7187 7.03125 10.8443 7.03125 9.76562C7.03125 8.68694 7.90569 7.8125 8.98438 7.8125C10.0631 7.8125 10.9375 8.68694 10.9375 9.76562ZM12.2853 16.366C11.301 16.8903 10.1773 17.1875 8.98421 17.1875C7.79112 17.1875 6.66744 16.8903 5.68314 16.366C6.17694 15.0216 7.46857 14.0625 8.98421 14.0625C10.4999 14.0625 11.7915 15.0216 12.2853 16.366Z"
				:stroke="color"
				stroke-width="1.5625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgMembershipCard',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
